import { VideoGameListItem } from '../Api/Games/types';
import { Review } from '../Api/Reviews/reviewSlice';
import { consoleList } from '../Redux/Types';

export interface NewReviewFormState {
	id: number;
	game: VideoGameListItem | null;
	platform: consoleList | null;
	title: string;
	details: string;
	rating: number;
	recommended?: boolean;
	highlights: ReviewHighlight[];
}

export interface SetGameAction {
	type: NewReviewFormReducerActionTypes.setGame;
	payload: VideoGameListItem;
}

export interface BindReviewAction {
	type: NewReviewFormReducerActionTypes.bind;
	payload: Review;
}

export interface SetPlatformAction {
	type: NewReviewFormReducerActionTypes.setPlatform;
	payload: consoleList;
}

export interface SetStringAction {
	type:
		| NewReviewFormReducerActionTypes.setTitle
		| NewReviewFormReducerActionTypes.setDetails;
	payload: string;
}

export interface SetNumberAction {
	type: NewReviewFormReducerActionTypes.setRating;
	payload: number;
}

export interface SetBooleanAction {
	type: NewReviewFormReducerActionTypes.setRecommendation;
	payload: boolean;
}

export interface AddHighlightAction {
	type: NewReviewFormReducerActionTypes.addHighlight;
	payload: ReviewHighlight;
}

export interface HighlightAction {
	type:
		| NewReviewFormReducerActionTypes.updateHighlight
		| NewReviewFormReducerActionTypes.removeHighlight;
	payload: { index: number; rating: number | null | undefined };
}

export type NewReviewFormReducerAction =
	| { type: NewReviewFormReducerActionTypes.reset }
	| BindReviewAction
	| SetGameAction
	| SetPlatformAction
	| SetStringAction
	| SetNumberAction
	| SetBooleanAction
	| AddHighlightAction
	| HighlightAction;

export enum NewReviewFormReducerActionTypes {
	reset,
	bind,
	setGame,
	setPlatform,
	setTitle,
	setDetails,
	setRating,
	setRecommendation,
	addHighlight,
	updateHighlight,
	removeHighlight
}

export interface ReviewHighlight {
	type: string;
	rating: number;
}
